const parseCardDate = (date: string | undefined) => {
  if (date === undefined) return;
  const newDate = new Date(Date.parse(date)).toString().split(' ');
  return `${newDate[1]} ${newDate[2]}, ${newDate[3]}`;
};

export default parseCardDate;
